// src/services/chat.service.js
import { api } from './api';

export const chatService = {
    async sendMessage(message, context = {}) {
        const response = await api.post('/chat/message', { message, context });
        return response.data;
    },

    async sendMessageWithHistory(message, context = {}) {
        const response = await api.post('/chat/message', { message, context });
        return response.data;
    },

    async getHistory() {
        const response = await api.get('/chat/history');
        return response.data;
    },

    // Conversation endpoints
    async getConversations(limit = 20, offset = 0) {
        const response = await api.get(`/chat/conversations?limit=${limit}&offset=${offset}`);
        return response.data;
    },

    async getConversation(id) {
        const response = await api.get(`/chat/conversations/${id}`);
        return response.data;
    },

    async getActiveConversation() {
        const response = await api.get('/chat/conversations/active');
        return response.data;
    },

    async createConversation(title = null) {
        const response = await api.post('/chat/conversations', { title });
        return response.data;
    },

    async updateConversation(id, title) {
        const response = await api.put(`/chat/conversations/${id}`, { title });
        return response.data;
    },

    async deleteConversation(id) {
        const response = await api.delete(`/chat/conversations/${id}`);
        return response.data;
    }
};
